export default __webpack_public_path__ + "static/media/nosotros_background.6a6325c6.png";